import React from "react";
import { SESSION_TOKEN } from "qpr-base/apicaller/api-consts";
import apiSessionStorage from "qpr-base/apicaller/api-session-storage";

const REFRESH_INTERVAL_MS = 60_000;

const getRefreshUrl = (): string => {
  const serverUrl = process.env.REACT_APP_SERVER_URL || "";
  if (!serverUrl || serverUrl === ".") {
    return "/api/EnticeServices/rest/authenticate/v2/refresh";
  }
  const baseUrl = serverUrl.endsWith("/") ? serverUrl.slice(0, -1) : serverUrl;
  const apiBaseUrl = baseUrl.endsWith("/api") ? baseUrl : `${baseUrl}/api`;
  return `${apiBaseUrl}/EnticeServices/rest/authenticate/v2/refresh`;
};

const SessionKeepAlive = (): null => {
  React.useEffect(() => {
    let requestInFlight = false;

    const refreshSession = async (): Promise<void> => {
      if (requestInFlight || document.visibilityState !== "visible") return;
      requestInFlight = true;
      try {
        const headers: HeadersInit = {};
        const token = apiSessionStorage.getSessionToken();
        if (token) headers[SESSION_TOKEN] = token;

        const response = await fetch(getRefreshUrl(), {
          method: "POST",
          credentials: "include",
          headers,
        });
        const refreshedToken = response.headers.get(SESSION_TOKEN);
        if (refreshedToken) apiSessionStorage.initSession(refreshedToken);
      } finally {
        requestInFlight = false;
      }
    };

    const intervalId = window.setInterval(() => void refreshSession(), REFRESH_INTERVAL_MS);
    return () => window.clearInterval(intervalId);
  }, []);

  return null;
};

export default SessionKeepAlive;